"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FAB", {
  enumerable: true,
  get: function get() {
    return _FAB["default"];
  }
});
var _FAB = _interopRequireDefault(require("./FAB"));